// React
import React, {useEffect} from 'react'
// React Router
import {Route, Routes} from "react-router-dom"
// Pages
import {Home} from "@App/Pages/Partner/Ayvens/Home"
import {Garages} from "@App/Pages/Common/Garages"
import {Profile} from "@App/Pages/Common/Profile"
import {Contact} from "@App/Pages/Common/Contact"
import {Layout} from "@App/Pages/Partner/Ayvens/Layout"
import {Summary} from "@App/Pages/Common/Summary"
import {TokenProtectedRoutes} from "@App/Components/common/TokenProtectedRoutes"
import {useSelector} from "react-redux";
import type {State} from "@App/state";
import i18n from "@App/utils/i18n";
import {useNavigateWithQueryParams} from "@App/hooks/useNavigateWithQueryParams";
import {Login} from "@App/Pages/Partner/Ayvens/Login";
import {Vehicle} from "@App/Pages/Partner/Ayvens/Vehicle";
import {UserIdProtectedRoutes} from "@App/Components/common/UserIdProtectedRoutes";

export function Ayvens() {
    const {navigateWithQuery} = useNavigateWithQueryParams()

    const organization = useSelector((state: State) => state.orders.organization)

    // change the language
    useEffect(() => {
        i18n.changeLanguage(organization.settings.language)
    }, [])

    // TODO normally, the hierarchy (/partner/ayvens) is automatically fetched from the parent routes, but for /login and /fahrzeug it doesn't seem to work properly.
    // For /fahrzeug, there doesn't seem to be an easy solution to go back to the "index" page defined for the Home Component, so I had to use this approach. Maybe there's something flaky here.
    return (
        <Routes>
            <Route path={"/"} element={<Layout/>}>
                <Route path={"/login"} element={<Login onSuccessfulLogin={() => navigateWithQuery("/partner/ayvens/fahrzeug", true)}/>}/>
                <Route element={<UserIdProtectedRoutes />}>
                    <Route path={"/fahrzeug"}
                           element={<Vehicle onSubmit={(token) => navigateWithQuery("/partner/ayvens", true, {"jwt": token})}/>}/>
                </Route>
                <Route element={<TokenProtectedRoutes />}>
                    <Route index={true}
                           element={<Home onSubmit={() => navigateWithQuery("werkstaetten", true)}/>}/>
                    <Route path={"/werkstaetten"}
                           element={<Garages onSubmit={() => navigateWithQuery("../werkstatt", true)}/>}/>
                    <Route path={"/werkstatt"}
                           element={<Profile onSubmit={() => navigateWithQuery("buchen", true)}/>}/>
                    <Route path={"/werkstatt/buchen"}
                           element={<Contact onSubmit={() => navigateWithQuery("erfolgreich", true)}/>}/>
                    <Route path={"/werkstatt/buchen/erfolgreich"}
                           element={<Summary/>}/>
                    <Route path={"*"}
                           element={<Home onSubmit={() => navigateWithQuery("werkstaetten", true)}/>}/>
                </Route>
            </Route>
        </Routes>
    )
}
